













import { computed, defineComponent, PropType } from '@vue/composition-api';
import { i18n } from './../../../../i18n';

const name = 'ttam-languages';
export default defineComponent({
  name,
  props: {
    value: {
      type: Array as PropType<string[]>,
      required: true,
      default: () => [],
    },
    options: {
      type: Array as PropType<{ id: string; label: string }[]>,
      default: () => [],
    },
  },
  setup(props, { emit }) {
    const _languageList = computed({
      get: () => props.value,
      set: val => {
        emit('input', val);
        emit('change', val);
      },
    });

    function selectedLabel(arr) {
      const count = arr?.length;
      if (!count) {
        return i18n.t('list_no_limit');
      }

      return i18n.t('adgroup_target_Language_model_selected', { num: count });
    }

    function onClearLanguages() {
      _languageList.value = [];
    }
    return {
      name,
      _languageList,
      selectedLabel,
      onClearLanguages,
    };
  },
});
